module.exports = __webpack_public_path__ + "img/环境5.192f9946.png";